var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmojie(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512.009 512.009",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F7B239"
    },
    cx: 256.004,
    cy: 256.004,
    r: 256.004
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E09B2D"
    },
    d: "M121.499,390.501C29.407,298.407,22.15,153.608,99.723,53.204 c-8.593,6.638-16.861,13.895-24.743,21.777c-99.974,99.974-99.974,262.065,0,362.038s262.065,99.974,362.038,0 c7.881-7.881,15.138-16.15,21.777-24.743C358.392,489.85,213.593,482.593,121.499,390.501z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E09B2D"
    },
    d: "M289.684,415.903c-23.779,0-48.406-3.249-66.761-6.416c-5.164-0.891-8.628-5.799-7.738-10.964 c0.891-5.164,5.799-8.63,10.964-7.738c22.959,3.96,56.094,8.074,83.571,5.168c5.204-0.553,9.882,3.227,10.434,8.439 c0.552,5.211-3.227,9.882-8.439,10.434C304.605,415.579,297.185,415.903,289.684,415.903z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4D4D4D"
    },
    d: "M107.619,174.513c8.571-14.347,23.667-22.913,40.38-22.913s31.809,8.566,40.38,22.913 c1.776,2.974,4.925,4.623,8.155,4.623c1.656,0,3.332-0.434,4.857-1.345c4.499-2.688,5.966-8.513,3.279-13.012 c-12.03-20.136-33.215-32.156-56.671-32.156s-44.641,12.022-56.671,32.156c-2.688,4.499-1.22,10.325,3.279,13.012 C99.109,180.482,104.932,179.012,107.619,174.513z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4D4D4D"
    },
    d: "M364.002,132.623c-23.456,0-44.641,12.022-56.671,32.156c-2.688,4.499-1.22,10.325,3.279,13.012 c4.501,2.69,10.326,1.22,13.012-3.279c8.571-14.347,23.667-22.913,40.38-22.913c16.713,0,31.809,8.566,40.38,22.913 c1.776,2.974,4.925,4.623,8.155,4.623c1.656,0,3.332-0.434,4.857-1.345c4.499-2.688,5.966-8.513,3.279-13.012 C408.643,144.644,387.457,132.623,364.002,132.623z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4D4D4D"
    },
    d: "M187.902,263.977c0-19.358-15.749-35.107-35.107-35.107h-45.004c-5.24,0-9.489,4.248-9.489,9.489 s4.248,9.489,9.489,9.489h13.837c-2.511,4.834-3.941,10.316-3.941,16.129c0,19.358,15.749,35.107,35.107,35.107 S187.902,283.334,187.902,263.977z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4D4D4D"
    },
    d: "M379.447,228.871h-45.003c-5.24,0-9.489,4.248-9.489,9.489c0,5.24,4.248,9.489,9.489,9.489h13.837 c-2.511,4.834-3.941,10.316-3.941,16.129c0,19.358,15.749,35.107,35.107,35.107c19.358,0,35.107-15.749,35.107-35.107 S398.805,228.871,379.447,228.871z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4D4D4D"
    },
    d: "M363.82,313.997c-5.235,0.254-9.272,4.703-9.018,9.937c0.526,10.83-2.833,19.008-10.265,25.005 c-31.888,25.724-126.909,7.783-160.831-1.301c-5.068-1.358-10.265,1.649-11.62,6.71c-1.356,5.061,1.646,10.263,6.707,11.62 c1.32,0.354,32.755,8.717,70.007,12.931c13.817,1.562,26.523,2.343,38.11,2.343c31.755,0,55.068-5.861,69.536-17.527 c12.316-9.933,18.141-23.626,17.312-40.7C373.503,317.78,369.041,313.746,363.82,313.997z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmojie);
export default __webpack_public_path__ + "static/media/emojie.6944fbb07bdb119c2d88cc93a7033a0a.svg";
export { ForwardRef as ReactComponent };